export const themeNames = {
  light: "light",
  dark: "dark"
};

export const getThemeName = (themeMode = "auto", systemDark = false) => {
  if (themeMode === "dark") return themeNames.dark;
  if (themeMode === "light") return themeNames.light;
  return systemDark ? themeNames.dark : themeNames.light;
};
